export {
  DiscountsProvider,
  useDiscounts,
  useIsExcludedFromDiscount,
} from './lib/DiscountsProvider'
export type { VipPercentDiscount, Discount } from './lib/types'
export { findHighestDiscountPercentage } from './lib/utils'
